import { render, staticRenderFns } from "./SidebarTables.vue?vue&type=template&id=4fa4e3d0&scoped=true&lang=pug&"
import script from "./SidebarTables.vue?vue&type=script&lang=ts&"
export * from "./SidebarTables.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarTables.vue?vue&type=style&index=0&id=4fa4e3d0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa4e3d0",
  null
  
)

export default component.exports